import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getIsHotelOnly } from 'src/store/view/selectors';
import {
  aviaSupplierCodeSelector,
  hotelSupplierCodeSelector,
  operatorIdSelector,
} from '../../../../store/selectors/tour';
import { getIsLoggedUser } from '../../../../store/selectors/user';
import { hotelSupplierCodeSelector as origPackageHotelSupllierCodeSelector } from '../../../../store/selectors/package';
import { ManagerInfo } from './ManagerInfo';

const mapStateToProps = (state, props: { tourId: string }) => ({
  operatorId: operatorIdSelector(state, props.tourId),
  isLoggedUser: getIsLoggedUser(state),
  aviaSupplierCode: getIsHotelOnly(state)
    ? undefined
    : aviaSupplierCodeSelector(state, props.tourId),
  hotelSupplierCode: getIsHotelOnly(state)
    ? origPackageHotelSupllierCodeSelector(state)
    : hotelSupplierCodeSelector(state, props.tourId),
});

const connector = connect(mapStateToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ManagerInfo);
